module.exports = __webpack_public_path__ + "img/ftm.53f4abcb.svg";